import { useEffect } from 'react';
import { dispatchProductView_Debounced } from '../dispatchHelper';
import { useWidgetContext } from './WidgetContext';
import { TypeProduct } from '../../types/TypeProduct';

export function useProductViewEvent(selectedVariation?: TypeProduct | null) {
  const widgetContext = useWidgetContext();
  useEffect(() => {
    if (selectedVariation) {
      dispatchProductView_Debounced(
        [selectedVariation.eventData],
        widgetContext,
      );
    }
  }, [selectedVariation, widgetContext]);
}
